import type { MeResponse } from '@rw/shared';
import { api } from '../lib/api';
import { useAuth } from '../stores/auth';
import { useLang } from '.';

/**
 * Keeps the account's language (used for push and bell notifications) in step with the app:
 * a language picked on this device is saved to the account; otherwise the account's is adopted.
 */
function sync() {
  const { token, user, setUser } = useAuth.getState();
  const { lang, chosen, setLang } = useLang.getState();
  if (!token || !user) return;
  const server = user.settings?.language;
  if (!server) {
    // A profile cached before languages existed: fetch the current one first.
    api<MeResponse>('/auth/me')
      .then((me) => {
        setUser(me);
        if (me.settings?.language) sync();
      })
      .catch(() => undefined);
    return;
  }
  if (server === lang) return;
  if (!chosen) return setLang(server, false);
  api<MeResponse>('/me/settings', { method: 'PATCH', body: { language: lang } })
    .then(setUser)
    .catch(() => undefined);
}

let started = false;
export function startLanguageSync() {
  if (started) return;
  started = true;
  useLang.subscribe((s, prev) => s.lang !== prev.lang && sync());
  useAuth.subscribe((s, prev) => s.user?.id !== prev.user?.id && sync());
  sync();
}
